module.exports = __webpack_public_path__ + "static/media/31.1052747c.png";